import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';
import * as Icon from 'react-feather';

const FormInput = ({
  className = '',
  inputClassName = '',
  label,
  type = 'text',
  name,
  value,
  placeholder,
  disabled,
  isShowLabel = true,
  touched,
  errors,
  onChange,
  onFocus,
  onBlur,
  icon,
  isIcon = false
}) => {
  const [showPass, setShowPass] = useState(false);

  const isError = touched && errors && touched[name] && errors[name];

  return (
    <FormGroup className={`${className} position-relative`}>
      {isShowLabel && (
        <Label htmlFor={name} className="d-flex justify-content-between align-items-center">
          {label}
          {isIcon ? <span>{icon}</span> : null}
        </Label>
      )}
      <Input
        className={`form-control ${isError ? 'is-invalid' : ''} ${inputClassName}`}
        name={name}
        type={showPass ? 'text' : type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled}
      />
      {type === 'password' && (
        <div
          className="position-absolute"
          style={{ top: '34px', right: '10px', cursor: 'pointer' }}>
          {showPass ? (
            <Icon.Eye size={20} onClick={() => setShowPass((prev) => !prev)} />
          ) : (
            <Icon.EyeOff size={20} onClick={() => setShowPass((prev) => !prev)} />
          )}
        </div>
      )}
      {isError && <span className="invalid-feedback">{errors[name]}</span>}
    </FormGroup>
  );
};

// PropTypes validation
FormInput.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isShowLabel: PropTypes.bool,
  touched: PropTypes.object,
  errors: PropTypes.object,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  icon: PropTypes.any,
  isIcon: PropTypes.bool
};

export default FormInput;
